var utils = require('util');

var EventEmitter = require('events').EventEmitter;

var CaseWorldUserInteraction = module.exports = function(caseWorldView) {
    this.caseWorldView = caseWorldView;

    var minCameraDistance = 1000;

    if(caseWorldView.model.variation === 'HEAVY' || caseWorldView.model.variation === 'PROFESSIONAL') {
        minCameraDistance = 1500;
    }

    this.cameraControl = new THREE.OrbitControls(this.caseWorldView.getCamera(), this.caseWorldView.getDomElement(), null, minCameraDistance);

    this.setMaxListeners(0);
};

utils.inherits(CaseWorldUserInteraction, EventEmitter);

CaseWorldUserInteraction.prototype.assignInteractions = function() {
    var that = this;

    that.changeCameraByMouse();
};


CaseWorldUserInteraction.prototype.changeCameraByMouse = function() {
    var that = this;

    that.cameraControl.autoRotate = false;
};

CaseWorldUserInteraction.prototype.updateCamera = function(delta) {
    this.cameraControl.update(delta);
};


CaseWorldUserInteraction.prototype.updateCameraCenter = function() {
    var that = this;

    var boundingBox = that._getSceneBoundingBox();
    var model = that.caseWorldView.getModel();

    var camera = that.caseWorldView.getCamera();

    var lookAtY = (model._height/2) + boundingBox.min.y - 50;

    that.cameraControl.center.y = lookAtY;
    if(!Detector.webgl && !that.isCameraOnTopPosition()) {
        camera.position.y = lookAtY;
    }

};

CaseWorldUserInteraction.prototype.positionCamera = function(delay, justPosition) {
    var that = this;
    delay = delay || 500;
    that.updateCameraCenter();
    var distanceToEdge = 100;
    var maxDistance = 200;
    var camera = that.caseWorldView.getCamera();
    var cameraCenter = that.cameraControl.center;
    var angle = that.caseWorldView.FIELD_OF_VIEW/2;


    angle = (angle*2*Math.PI)/360;
    var cameraPosition = camera.position.clone();
    var distanceToLookAt = Math.sqrt(cameraPosition.distanceToSquared(that.cameraControl.center));

    var planeMinusX = -Math.tan(angle)*distanceToLookAt;
    var planePlusX = Math.tan(angle)*distanceToLookAt;
    var boundingBox = that._getSceneBoundingBox();

    var differentLeft = planePlusX - Math.abs(boundingBox.min.x/2);
    var differntRight = planePlusX -  Math.abs(boundingBox.max.x/2);
    var newPlaneSize = 0;

    if(differentLeft < differntRight) {
        newPlaneSize = distanceToEdge + Math.abs(planePlusX - differentLeft);
    }else {
        newPlaneSize = distanceToEdge + Math.abs(planePlusX - differntRight);
    }


    var viewLength = 2 * newPlaneSize;
    var viewHeight = that._calculateHeight(viewLength);

    var newDistance = newPlaneSize/Math.tan(angle);
    var cameraStretch = newDistance / distanceToLookAt;
    var newPosition = cameraPosition.clone().multiplyScalar(cameraStretch);
    /////////

    var highestY = cameraCenter.y + (viewHeight / 2);
    var highestPoint = new THREE.Vector3(cameraCenter.x, highestY, cameraCenter.z);

    var vectorToHighestPoint = highestPoint.clone().sub(newPosition.clone());//newPosition.sub(highestPoint);

    var vectorToCenter = cameraCenter.clone().sub(newPosition.clone());//newPosition.sub(cameraCenter);

    var heightAngle = vectorToHighestPoint.angleTo(vectorToCenter);

    var differenceTop = highestY - (boundingBox.max.y);

    var newHeight = distanceToEdge + (boundingBox.max.y);

    var newHeightDistance = newHeight/Math.tan(heightAngle);
    var heightStretch = 1;
    if(differenceTop < distanceToEdge) {
        heightStretch = newHeightDistance / newDistance;
        newPosition = cameraPosition.clone().multiplyScalar(cameraStretch*heightStretch);
    }

    if(justPosition === true) {
        return newPosition;
    }

    ////////

    if(differentLeft < distanceToEdge || differntRight < distanceToEdge || differentLeft > maxDistance || differntRight > maxDistance || differenceTop < distanceToEdge) {

        if(cameraShouldBeUpdated(viewHeight, viewLength, cameraStretch, heightStretch)) {
            that.moveCameraTo(cameraPosition, newPosition, false, delay);
        }
    }



    function cameraShouldBeUpdated(viewHeight, viewLength, cameraStretch, heightStretch) {
        var model = that.caseWorldView.getModel();

        var height = model._height;

        var depth = model._depth;

        var cameraOnTopPosition = that.isCameraOnTopPosition();
        if(cameraStretch < 1 && heightStretch < 1) {
            return viewHeight > height && viewLength > depth && !cameraOnTopPosition;
        }

        return !cameraOnTopPosition;// || (cameraOnTopPosition && !Detector.webgl); //true;
    }
};

CaseWorldUserInteraction.prototype.moveCameraTo = function(cameraPosition, position, returnTween, delay) {
    var that = this;
    var camera = that.caseWorldView.getCamera();

    var center = that.cameraControl.center;
    delay = delay || 500;

    if(!Detector.webgl) {
        if(!that.isCameraOnTopPosition(position)) {

            position.y = center.y;
        }

        camera.position = position;
        camera.lookAt(center);
        that.emit('cameraAnimationDone');
        return;
    }

    var tween = new TWEEN.Tween({x: cameraPosition.x,y: cameraPosition.y, z: cameraPosition.z})
        .to({x: position.x, y: position.y, z: position.z}, delay);
    tween.easing(TWEEN.Easing.Quadratic.InOut);
    tween.onUpdate(function() {
        camera.position.set(this.x, this.y, this.z);
    })
        .onComplete(function() {
            that.emit('cameraAnimationDone');
        });

    if(that.isCameraOnTopPosition(position)) {
        setTimeout(function() {
            that.emit('cameraAnimationDone');
        }, delay);
    }

    if(returnTween) {
        return tween;
    }

    tween.start();

};


CaseWorldUserInteraction.prototype._calculateHeight = function(viewLength) {
    var that = this;

    var aspectRation = that.caseWorldView.ASPECT_RATIO;

    return viewLength/aspectRation;

};



CaseWorldUserInteraction.prototype._getSceneBoundingBox = function() {
    var that = this;
    var scene = that.caseWorldView.getScene();

    var boundingBox = new THREE.BoundingBoxHelper(scene);
    boundingBox.update();

    return boundingBox.box;
};

CaseWorldUserInteraction.prototype.isCameraOnTopPosition = function(position){
    var that = this;

    var camera = that.caseWorldView.getCamera();

    var x = camera.position.x;

    var z = camera.position.z;

    var tolerance = 0.01;

    if(position) {
        x = position.x;

        z = position.z;
    }

    return Math.abs(x) < tolerance && Math.abs(z) < tolerance;

};

CaseWorldUserInteraction.prototype.cameraFullRotation = function(startPoint, steps1) {
    var that = this;

    var camera = that.caseWorldView.getCamera();

    var cameraPosition = that.positionCamera(0, true); //camera.position;

    var initalAngle = cameraPosition.angleTo(new THREE.Vector3(0, 0, 1));

    var turns = 1 * 360;
    var yPosition = cameraPosition.y; // + turns;

    var radius = cameraPosition.length();

    var rotationEnd = turns + (initalAngle * (180/Math.PI));
    var radianStep = (2*Math.PI)/ 360;
    var steps = initalAngle/radianStep;

    var path = new THREE.Path([new THREE.Vector2(0, steps)]);
    var startPoint = startPoint || 50;

    path.bezierCurveTo(startPoint, 0, 0, rotationEnd, startPoint, rotationEnd);
    var steps1 = steps1 || 200;
    var points = path.getTransformedPoints(steps1);

    var newPosition = new THREE.Vector3(getXCoordinate(initalAngle, radius), yPosition, getZCoordinate(initalAngle, radius));
    var delay = 2;
    var initialTween = that.moveCameraTo(cameraPosition, newPosition, true, 1);
    var rememberedPosition = newPosition.clone();
    var rememberedTween = initialTween;
    var newTween = initialTween;
    var index = 1;// 200;
    while(steps <= rotationEnd && index < points.length) {

        newPosition = new THREE.Vector3(getXCoordinate(steps*radianStep, radius), yPosition, getZCoordinate(steps*radianStep, radius));

        newTween = that.moveCameraTo(rememberedPosition, newPosition, true, delay);
        rememberedTween.chain(newTween);
        rememberedTween = newTween;
        rememberedPosition = newPosition.clone();

        var fullRotationDistance = rotationEnd - steps;
        var regularStep = 1;
        var newStep = points[index].y;
        if(fullRotationDistance < regularStep && fullRotationDistance > 0) {

            steps += fullRotationDistance;
        } else if(steps < newStep) {
            steps = newStep;
        }

        index++;

    }

    rememberedTween.onComplete(function() {
        that.emit('fullCameraRotationDone');
    });

    initialTween.start();


    function getXCoordinate(angle, radius) {
        return radius*Math.sin(angle);
    }

    function getZCoordinate(angle, radius) {
        return radius*Math.cos(angle);
    }
};

CaseWorldUserInteraction.prototype.tmpCameraFullRotation = function(speed) {
    var that = this;

    //that.once('cameraAnimationDone', function() {
    var camera = that.caseWorldView.getCamera();

    var cameraPosition = camera.position; //camera.position;

    var initalAngle = cameraPosition.angleTo(new THREE.Vector3(0, 0, 1));

    var yPosition = cameraPosition.y;

    var radius = cameraPosition.length();

    var rotationEnd = 2*360 + (initalAngle * (180/Math.PI));
    var radianStep = (2*Math.PI)/ 360;
    var steps = initalAngle/radianStep;

    var newPosition = new THREE.Vector3(getXCoordinate(initalAngle, radius), yPosition, getZCoordinate(initalAngle, radius));
    var delay = 2;
    var initialTween = that.moveCameraTo(cameraPosition, newPosition, true, 1);
    var rememberedPosition = newPosition.clone();
    var rememberedTween = initialTween;
    var newTween = initialTween;
    var index = 200;

    speed = speed || 2;
    while(steps <= rotationEnd) {

        newPosition = new THREE.Vector3(getXCoordinate(steps*radianStep, radius), yPosition, getZCoordinate(steps*radianStep, radius));

        newTween = that.moveCameraTo(rememberedPosition, newPosition, true, delay);
        rememberedTween.chain(newTween);
        rememberedTween = newTween;
        rememberedPosition = newPosition.clone();

        var fullRotationDistance = rotationEnd - steps;
        var regularStep = 6;
        if(fullRotationDistance < regularStep && fullRotationDistance > 0) {
            steps += fullRotationDistance;

        } else {
            steps += speed;
            index++;
        }
    }

    //rememberedTween.chain(that.moveCameraTo(rememberedPosition, new THREE.Vector3(getXCoordinate(initalAngle, radius), yPosition, getZCoordinate(initalAngle, radius)), true, delay + 200));

    rememberedTween.onComplete(function() {
        that.emit('fullCameraRotationDone');
    });

    initialTween.start();
    //});

    //that.positionCamera(0);

    function getXCoordinate(angle, radius) {
        return radius*Math.sin(angle);
    }

    function getZCoordinate(angle, radius) {
        return radius*Math.cos(angle);
    }
};


// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Views/CaseWorldUserInteraction.js